import React, { Dispatch, FC, SetStateAction, useCallback, useEffect, useRef, useState } from 'react';
import sortIcon from "../../../../assests/img/delta-sort-icon.svg";
import ascendingIcon from "../../../../assests/img/ascending-icon.svg";
import descendingIcon from "../../../../assests/img/descending-icon.svg";
import ButtonSwitch from 'Components/Common/components/Button/ButtonSwitch';
import TextSelector from './TextSelector';
import { DELTA, PRODUCT_TYPE, SORT } from '../ProductConstants';
import { TFilters } from 'types/hooks/useTable';
import Utils from 'Common/Utils';

type MyProps = {
  filters: TFilters,
  setFilters: Dispatch<SetStateAction<TFilters>>
}

const ProductSort: FC<MyProps> = ({filters, setFilters}) => {
    const [showMenu, setShowMenu] = useState<boolean>(false);
    const icons = [ascendingIcon, descendingIcon];
    const sortTexts: {[x: string]: string} = {'Ascending': "ASC", 'Descending': "DESC"};
    const texts: {[x: string]: string} = {'Name': "name", 'Date Created': "created_at", 'Date Modified': "updated_at"}
    const productTypes: {[x: string]: string|undefined} = {All: undefined, 'Parent/Child': "parent", 'Individual': "individual"};
    const deltaTypes = ['All', 'Live', 'Draft', 'Rollback'];

    const ref = useRef<HTMLDivElement>(null);

    const handleClickOutside = useCallback(
      (e: MouseEvent) =>
        Utils.run_callback_on_click_outside_ref(e, ref, () => setShowMenu(false)),
      [ref]
    );

    useEffect(() => {
      // close dropdown if clicked outside
      showMenu
        ? document.addEventListener("mousedown", handleClickOutside)
        : document.removeEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [ref, handleClickOutside, showMenu]);

    const handleTypeChange = (index: number) => {
      setFilters(prev => {
        return ({
          ...prev,
          product_type: Object.values(productTypes)[index]
        })
      })
    }

    const handleSortbySelect = (text: string) => {
      setFilters(prev => {
        return ({
          ...prev,
          sort_by: texts[text]
        })
      })
    }

    const handleSortTypeSelect = (text: string) => {
      setFilters(prev => {
        return ({
          ...prev,
          sort_type: sortTexts[text]
        })
      })
    }

  return (
    <React.Fragment>
        <div ref={ref} onClick={() => setShowMenu(true)} className={`${showMenu ? 'tw-bg-[#EBECF0]' : ''} tw-relative hover:tw-bg-[#EBECF0] tw-p-2 tw-ms-3 tw-rounded-[4px] tw-flex tw-flex-row tw-items-center tw-justify-center tw-gap-[6px]`}>
            <img className={`tw-w-[16.56px] tw-h-[15px]`} alt="Filter" src={sortIcon}/>
            <button className={`tw-text-sm tw-font-normal tw-text-[#172B4D]`}>{SORT}</button>
          {showMenu &&
          <div className={`tw-absolute tw-top-full tw-left-0 tw-pb-2 tw-w-[260px] tw-rounded-[4px] tw-bg-white tw-ring-1 tw-ring-[#EBECF0]`}>
            <div className={`tw-my-2 tw-mx-2`}>
              <TextSelector 
              selected={filters?.sort_type ? Object.keys(sortTexts).find(key => sortTexts[key] === filters?.sort_type): Object.keys(sortTexts)[0]} 
              handleChange={handleSortTypeSelect} 
              texts={Object.keys(sortTexts)} 
              icons={icons} />
              <div className={`tw-box-border tw-mt-2 tw-w-auto tw-h-px tw-border-t-[1px] tw-border-solid tw-border-[#D1D1D6]`} />  
              <TextSelector 
                selected={filters?.sort_by ? Object.keys(texts).find(key => texts[key] === filters?.sort_by): Object.keys(texts)[0]} 
                handleChange={handleSortbySelect}
                texts={Object.keys(texts)} />
              <div className={`tw-box-border tw-mt-2 tw-w-auto tw-h-px tw-border-t-[1px] tw-border-solid tw-border-[#D1D1D6]`} />
            </div>
            <div className={`tw-ms-2 tw-me-2 tw-mb-2`}>
              {/* <label className={`tw-block tw-px-1 tw-py-1 tw-font-bold tw-text-xs tw-text-[#A4A8AF]`}>{DELTA}</label>  
              <ButtonSwitch labels={deltaTypes}/>
              <div className={`tw-box-border tw-my-2 tw-w-auto tw-h-px tw-border-t-[1px] tw-border-solid tw-border-[#D1D1D6]`} /> */}
              <label className={`tw-block tw-px-1 tw-py-1 tw-font-bold tw-text-xs tw-text-[#A4A8AF]`}>{PRODUCT_TYPE}</label> 
              <ButtonSwitch 
                selected={filters.product_type ? Object.values(productTypes).indexOf(filters.product_type) : 0} 
                handleChange={handleTypeChange} 
                labels={Object.keys(productTypes)}
                /> 
            </div>
          </div> 
          }
        </div>
    </React.Fragment>
  )
}

export default ProductSort;